import React, { CSSProperties } from 'react';
import styles from './MaxWidthContainer.module.scss';
import { ContainerSizes } from '../../../constants/ContainerSizes';

interface MaxWidthContainerProps {
  children: React.ReactNode | React.ReactNode[];
  size?: ContainerSizes | string;
  style?: CSSProperties;
  className?: string;
}

export const MaxWidthContainer = ({
  style = {},
  children,
  size = ContainerSizes.LARGE,
  className = '',
}: MaxWidthContainerProps) => (
  <div style={{ ...style }} className={`${styles.root} ${styles[size]} ${className}`}>
    {children}
  </div>
);
